import React, { useContext, useState, useEffect } from "react";
import Sidebar, { SidebarItem } from "../components/ui/Sidebar";
import axios from "axios";
import {
  LayoutDashboard,
  BookA,
  BookOpen,
  ClipboardList,
  LogOut,
} from "lucide-react";

import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/ui/NavBar";
import EnhancedDashboardLayout from "../components/ui/DashBoardLayout";
import { FiAlertTriangle } from "react-icons/fi";
import Button from "components/ui/Button";
import ChatCommunication from "./ChatCommunication";

const DashboardComponent = () => {
  return (
    <div className="space-y-4">
      <h2>Dashboard</h2>
    </div>
  );
};

const NotificationBanner = () => {
  const navigate = useNavigate();

  const handleReviewClick = () => {
    navigate("/ai-rewrite-approval");
  };

  return (
    <div className="w-full p-4 bg-yellow-100 rounded-2xl">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
        <div className="w-8 h-8 min-w-8 bg-black rounded-full flex items-center justify-center">
            <FiAlertTriangle className="w-4 h-4 text-white" />
          </div>

          <span className="ml-4 text-black font-medium text-base">
            You have 2 escalation messages to review
          </span>
        </div>

        <Button className="black-button flex" onClick={handleReviewClick}>
          Review
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 ml-1"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </Button>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [activeComponent, setActiveComponent] = useState("Dashboard");
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const renderActiveComponent = () => {
    switch (activeComponent) {
      case "Dashboard":
        return (
          <div className="container">
            <h4>Dashboard</h4>
          </div>
        );
      default:
        return (
          <div className="space-y-4">
            <h2>Dashboard</h2>
          </div>
        );
    }
  };

  return (
    <div className="container">
      {/* <NotificationBanner /> */}
      <ChatCommunication/>
    </div>
  );
};

export default Dashboard;
